import React from 'react';

import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import LoaderIcon from '@lt/components/icons-react/rebrand/Loader';
import Testimonial from '../../components/Testimonial';

import { type Props } from './types';
import styles from './testimonials.module.css';

const Testimonials = ({ items, load, isFetching, isMobile }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('checkout.testimonial.title')}</h2>
      <div className={styles.testimonials}>
        {isFetching && <LoaderIcon className={styles.loader} />}
        {items &&
          items.map((item) => (
            <Testimonial isMobile={isMobile} key={item.id} data={item} />
          ))}
        <Button
          functional
          type="button"
          onClick={load}
          disabled={isFetching}
          className={styles.button}
        >
          {t('checkout.testimonial.show', {
            context: isMobile ? 'mobile' : 'desktop',
          })}
        </Button>
      </div>
    </div>
  );
};

export default Testimonials;
